export default __webpack_public_path__ + "static/media/demon-slayer.62defd19.png";